// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* input {
  background: #ecf0f3;
  padding: 10px;
  padding-left: 20px;
  height: 40px;
  font-size: 14px;
  border-radius: 50px;
  box-shadow: inset 0px 0px 1px 1px #cbced1, inset 1px 1px 1px white;
} */

select {
  /* background: #ecf0f3; */
  /* padding: 10px; */
  /* padding-left: 20px; */
  /* height: 40px; */
  /* font-size: 14px; */
  /* border-radius: 50px; */
  /* box-shadow: inset 0px 0px 1px 1px #cbced1, inset 1px 1px 1px white; */
  cursor: pointer;
}


@media (min-width: 1024px) {
  .Partners_container__WvWta {
      clip-path: polygon(100% calc(100% - 70px),200px 100%,0 calc(100% - 110px),0 0,100% 0);
  }
  .Partners_container__WvWta:before {
      width: 180px;
      height: 180px;
      border-top-right-radius: 40px;
      bottom: -35px;
      left: 0;
  }

}
@media (min-width: 768px) and (max-width: 1023px) {
  .Partners_container__WvWta {
      clip-path: polygon(100% calc(100% - 50px),130px 100%,0 calc(100% - 70px),0 0,100% 0);
  }

  .Partners_container__WvWta:before {
    width: 120px;
    height: 120px;
    border-top-right-radius: 40px;
    bottom: -25px;
    left: 0;
  }
}
@media (min-width: 320px) and (max-width: 768px){
  .Partners_container__WvWta {
      clip-path: polygon(100% calc(100% - 50px),97px 100%,0 calc(100% - 63px),0 0,100% 0);
  }
  .Partners_container__WvWta:before {
    width: 90px;
    height: 90px;
    border-top-right-radius: 20px;
    bottom: -15px;
    left: -3px;
  }
  .Partners_wrapper__G4bTB {
    padding: 3rem 2rem 7rem;
    width: 100%;
    flex-direction: column;
    gap: 1.5rem;
    font-size: .75rem;
    text-align: center;
}

}



.Partners_container__WvWta:before {
  content: "";
  /* background: linear-gradient(60deg,#2166ba,#bfcaf6); */
  background: linear-gradient(60deg,#ba2121,#f6bfbf);;
  position: absolute;
  transform: rotate(-15deg);
}


.Partners_container__WvWta {
  /* background: linear-gradient(0deg,#023978,#023978); */
  background:linear-gradient(rgb(135 19 19) 50%, rgb(1 2 2) 100%);
  position: relative;
  min-height: 400px;
}

.Partners_wrapper__G4bTB {
  max-width: 81.75rem;
  /* margin: auto; */
  /* padding: 5rem 7rem 10rem; */
  padding: 1rem 1rem 1rem;

  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/hnh/css/application.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;;AAEH;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,wEAAwE;EACxE,eAAe;AACjB;;;AAGA;EACE;MAEI,qFAAqF;EACzF;EACA;MACI,YAAY;MACZ,aAAa;MACb,6BAA6B;MAC7B,aAAa;MACb,OAAO;EACX;;AAEF;AACA;EACE;MAEI,oFAAoF;EACxF;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,OAAO;EACT;AACF;AACA;EACE;MAEI,mFAAmF;EACvF;EACA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;AAIA;EACE,WAAW;EACX,wDAAwD;EACxD,kDAAkD;EAClD,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,uDAAuD;EACvD,+DAA+D;EAC/D,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;;EAEvB,aAAa;EACb,8BAA8B;AAChC","sourcesContent":["/* input {\n  background: #ecf0f3;\n  padding: 10px;\n  padding-left: 20px;\n  height: 40px;\n  font-size: 14px;\n  border-radius: 50px;\n  box-shadow: inset 0px 0px 1px 1px #cbced1, inset 1px 1px 1px white;\n} */\n\nselect {\n  /* background: #ecf0f3; */\n  /* padding: 10px; */\n  /* padding-left: 20px; */\n  /* height: 40px; */\n  /* font-size: 14px; */\n  /* border-radius: 50px; */\n  /* box-shadow: inset 0px 0px 1px 1px #cbced1, inset 1px 1px 1px white; */\n  cursor: pointer;\n}\n\n\n@media (min-width: 1024px) {\n  .Partners_container__WvWta {\n      -webkit-clip-path: polygon(100% calc(100% - 70px),200px 100%,0 calc(100% - 110px),0 0,100% 0);\n      clip-path: polygon(100% calc(100% - 70px),200px 100%,0 calc(100% - 110px),0 0,100% 0);\n  }\n  .Partners_container__WvWta:before {\n      width: 180px;\n      height: 180px;\n      border-top-right-radius: 40px;\n      bottom: -35px;\n      left: 0;\n  }\n\n}\n@media (min-width: 768px) and (max-width: 1023px) {\n  .Partners_container__WvWta {\n      -webkit-clip-path: polygon(100% calc(100% - 50px),130px 100%,0 calc(100% - 70px),0 0,100% 0);\n      clip-path: polygon(100% calc(100% - 50px),130px 100%,0 calc(100% - 70px),0 0,100% 0);\n  }\n\n  .Partners_container__WvWta:before {\n    width: 120px;\n    height: 120px;\n    border-top-right-radius: 40px;\n    bottom: -25px;\n    left: 0;\n  }\n}\n@media (min-width: 320px) and (max-width: 768px){\n  .Partners_container__WvWta {\n      -webkit-clip-path: polygon(100% calc(100% - 50px),97px 100%,0 calc(100% - 63px),0 0,100% 0);\n      clip-path: polygon(100% calc(100% - 50px),97px 100%,0 calc(100% - 63px),0 0,100% 0);\n  }\n  .Partners_container__WvWta:before {\n    width: 90px;\n    height: 90px;\n    border-top-right-radius: 20px;\n    bottom: -15px;\n    left: -3px;\n  }\n  .Partners_wrapper__G4bTB {\n    padding: 3rem 2rem 7rem;\n    width: 100%;\n    flex-direction: column;\n    gap: 1.5rem;\n    font-size: .75rem;\n    text-align: center;\n}\n\n}\n\n\n\n.Partners_container__WvWta:before {\n  content: \"\";\n  /* background: linear-gradient(60deg,#2166ba,#bfcaf6); */\n  background: linear-gradient(60deg,#ba2121,#f6bfbf);;\n  position: absolute;\n  transform: rotate(-15deg);\n}\n\n\n.Partners_container__WvWta {\n  /* background: linear-gradient(0deg,#023978,#023978); */\n  background:linear-gradient(rgb(135 19 19) 50%, rgb(1 2 2) 100%);\n  position: relative;\n  min-height: 400px;\n}\n\n.Partners_wrapper__G4bTB {\n  max-width: 81.75rem;\n  /* margin: auto; */\n  /* padding: 5rem 7rem 10rem; */\n  padding: 1rem 1rem 1rem;\n\n  display: flex;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
